<template>
  <v-menu v-model="menu" offset-y attach=".filter-btn">
    <template v-slot:activator="{}">
      <v-btn
        class="filter-btn weight5 size-20 mt-6 mb-10 white--text"
        rounded
        :ripple="!menu"
        @click="menu = !menu"
      >
        {{selectedFilters.length ? selectedFilters.length : ''}} Filter
        <v-icon class="p-absolute" style="right: 0">
          {{menu ? 'mdi-close' : 'mdi-chevron-down'}}
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in ['BMW', 'JEEP', 'TESLA']"
        :key="index"
        @click.stop="toggleFilter(item)"
      >
        <v-list-item-title
          :class="selectedFilters.indexOf(item) !== -1 && 'font-weight-bold'"
        >{{ item }}</v-list-item-title>
        <v-list-item-icon
          v-if="selectedFilters.indexOf(item) !== -1"
          class="p-absolute"
          style="right: 20px; top: -2.5px"
        >
          <v-icon>mdi-check</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'filters',
  data: () => ({
    menu: false,
    selectedFilters: []
  }),
  methods: {
    toggleFilter(item) {
      let index = this.selectedFilters.indexOf(item);

      if(index !== -1)
        this.selectedFilters.splice(index, 1);
      else
        this.selectedFilters.push(item);
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-btn {
  position: relative;
  width: calc(100% * 0.88);
  max-width: 362px;
  min-height: 50px;
  color: white;
  background: linear-gradient(15.36deg, #021325 0%, #2F5678 100%);
  box-shadow: 0px 2px 4px rgba(80, 80, 80, 0.12);
  border-radius: 25px;
  z-index: 10;

  .v-menu__content {
    min-width: 100% !important;
    top: 100% !important;
    left: 0px !important;
  }

  .mdi-check::before {
    font-weight: bolder;
    color: #020B2D;
  }
}
</style>